module.exports = __webpack_public_path__ + "img/PXL_20230523_142012291.30895d27.jpg";